<template>
  <div class="record_connect">
    <el-divider content-position="left">审核列表</el-divider>
    <el-collapse style="margin-bottom: 0.2rem" v-model="activeOpen">
      <el-collapse-item title="筛选" name="1">
        <div style="padding: 10px">
          <el-row class="mb-20 search-row" :gutter="20">
            <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>申请时间</span></el-col>
            <el-col :xs="24" :sm="8" :md="5" :lg="6">
              <el-date-picker
                v-model="searchArr.applicat_at"
                size="mini"
                type="date"
                placeholder="选择申请时间"
              >
              </el-date-picker>
            </el-col>
            <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>交接时间</span></el-col>
            <el-col :xs="24" :sm="8" :md="5" :lg="6">
              <el-date-picker
                v-model="searchArr.connect_at"
                size="mini"
                type="date"
                placeholder="选择交接时间"
              >
              </el-date-picker>
            </el-col>
            <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>归档时间</span></el-col>
            <el-col :xs="24" :sm="8" :md="5" :lg="6">
              <el-date-picker
                v-model="searchArr.return_at"
                size="mini"
                type="date"
                placeholder="选择归档时间"
              >
              </el-date-picker>
            </el-col>
            <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>驳回时间</span></el-col>
            <el-col :xs="24" :sm="8" :md="5" :lg="6">
              <el-date-picker
                v-model="searchArr.reject_at"
                size="mini"
                type="date"
                placeholder="选择驳回时间"
              >
              </el-date-picker>
            </el-col>
            <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>申请人</span></el-col>
            <el-col :xs="24" :sm="8" :md="5" :lg="6">
              <el-select
                :filterable="true"
                multiple
                collapse-tags
                v-model="searchArr.applicat_uid"
                placeholder="请选择"
                size="mini"
                clearable
              >
                <el-option
                  v-for="(item, index) in users"
                  :key="index"
                  :label="item.username"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>申请状态</span></el-col>
            <el-col :xs="24" :sm="8" :md="5" :lg="6">
              <el-select
                :filterable="true"
                collapse-tags
                v-model="searchArr.applicat_status"
                placeholder="请选择"
                size="mini"
                clearable
              >
                <el-option :value="1" label="申请中"></el-option>
                <el-option :value="2" label="已交接"></el-option>
                <el-option :value="3" label="已归档"></el-option>
                <el-option :value="4" label="已驳回"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="text-align: center;">
            <el-button type="primary" size="mini" @click="handleASearSub">查询</el-button>
            <el-button type="danger" size="mini" @click="handleASearClear"
              >清除</el-button
            >
          </el-row>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-row class="mt-50 mb-10">
      <el-col :span="6" :offset="18" class="tr">
        <el-input v-model="search" size="mini" placeholder="关键词：公司名" />
      </el-col>
    </el-row>
    <div class="middle-table">
    <el-table
    height="calc(100vh - 326px)"
      :data="pageData"
      size="medium"
      style="width: 100%; margin-top: 0.2rem"
      v-cloak
      border
    >
      <el-table-column label="公司" fixed width="300">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleGetOperate(scope.row.id)">{{
            scope.row.company_name ? scope.row.company_name : ""
          }}</el-link>
          <el-tooltip class="item" effect="dark" content="复制" placement="top"
            ><i
              class="el-icon-document-copy"
              style="margin-left: 0.1rem; cursor: pointer"
              @click="copySome(scope.row.company_name)"
            ></i
          ></el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in col"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        width="150"
      >
        <template slot-scope="scope">
          <span v-if="item.prop === 'applicat_at'">
            <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
          </span>
          <span v-else-if="item.prop === 'connect_at'">
            <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
          </span>
          <span v-else-if="item.prop === 'return_at'">
            <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
          </span>
          <span v-else-if="item.prop === 'reject_at'">
            <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
          </span>
          <div v-else :content="scope.row[item.prop] + ''" placement="top">
            <span class="count-style">{{ scope.row[item.prop] }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-tooltip content="通过档案使用申请" placement="top">
            <el-popconfirm
              @onConfirm="handleConnectApplicat(scope.$index, scope.row)"
              confirmButtonText="确定"
              cancelButtonText="取消"
              icon="el-icon-s-check"
              iconColor="#409EFF"
              title="确认交接这个申请的材料吗？"
            >
              <el-button
                :disabled="
                  (applicatConnectStatus =
                    scope.row.applicat_status === 2 ||
                    scope.row.applicat_status === 3 ||
                    scope.row.applicat_status === 4)
                "
                type="primary"
                slot="reference"
                size="mini"
                icon="el-icon-s-check"
                circle
              ></el-button>
            </el-popconfirm>
          </el-tooltip>
          <el-tooltip content="借出档案归档" placement="top">
            <el-popconfirm
              @onConfirm="handleReturnApplicat(scope.$index, scope.row)"
              confirmButtonText="确定"
              cancelButtonText="取消"
              icon="el-icon-s-order"
              iconColor="#67c23a"
              title="确认材料均已归档？"
            >
              <el-button
                :disabled="
                  (applicatConnectStatus =
                    scope.row.applicat_status === 1 ||
                    scope.row.applicat_status === 3 ||
                    scope.row.applicat_status === 4)
                "
                type="success"
                slot="reference"
                size="mini"
                icon="el-icon-s-order"
                circle
              ></el-button>
            </el-popconfirm>
          </el-tooltip>
          <el-tooltip content="发送钉钉提醒归档" placement="top">
            <el-popconfirm
              @onConfirm="handleAlertApplicat(scope.row)"
              confirmButtonText="确定"
              cancelButtonText="取消"
              icon="el-icon-alarm-clock"
              iconColor="yellow"
              title="提醒申请人归还材料？"
            >
              <el-button
                :disabled="
                  (applicatConnectStatus =
                    scope.row.applicat_status === 1 ||
                    scope.row.applicat_status === 3 ||
                    scope.row.applicat_status === 4)
                "
                type="warning"
                slot="reference"
                size="mini"
                icon="el-icon-alarm-clock"
                circle
              ></el-button>
            </el-popconfirm>
          </el-tooltip>
          <el-tooltip content="驳回档案申请" placement="top">
            <el-popconfirm
              @onConfirm="handleRejectApplicat(scope.$index, scope.row)"
              confirmButtonText="确定"
              cancelButtonText="取消"
              icon="el-icon-close"
              iconColor="red"
              title="确认驳回这个申请吗？"
            >
              <el-button
                :disabled="
                  (applicatConnectStatus =
                    scope.row.applicat_status === 2 ||
                    scope.row.applicat_status === 3 ||
                    scope.row.applicat_status === 4)
                "
                type="danger"
                slot="reference"
                size="mini"
                icon="el-icon-close"
                circle
              ></el-button>
            </el-popconfirm>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="page-footer">
    <el-pagination
      background
      class="pagination-style"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="search ? pageOption.searchCurrentPage : pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    </div>
    <el-drawer title="" :visible.sync="ContactDrawer" direction="rtl" size="40%">
      <el-tabs style="padding: 0 0.2rem 0 0.4rem">
        <el-tab-pane label="申请人操作记录">
          <div class="blocka">
            <el-timeline>
              <el-timeline-item
                v-for="(OperationRecord, index) in OperationRecord"
                :key="index"
                :timestamp="OperationRecord.created_at"
                placement="top"
              >
                <el-card>
                  <p>{{ OperationRecord.operate }}</p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-drawer>
  </div>
</template>

<script>
import DateFormatter from "common/DateFormatter";
export default {
  name: "record_connect",
  components: { DateFormatter },
  data() {
    return {
      activeOpen: '',
      search: "",
      searchArr: {
        applicat_at: "",
        connect_at: "",
        return_at: "",
        reject_at: "",
        applicat_uid: "",
        applicat_status: "",
      },
      loading: false,
      companies: [],
      recordApplicats: [],
      OperationRecord: [],
      col: [
        {
          label: "当前状态",
          prop: "status_name",
        },
        {
          label: "申请人",
          prop: "applicat_username",
        },
        {
          label: "申请时间",
          prop: "applicat_at",
        },
        {
          label: "档案材料",
          prop: "detail_ids",
        },
        {
          label: "原因说明",
          prop: "use_cause",
        },
        {
          label: "交接时间",
          prop: "connect_at",
        },
        {
          label: "交接人",
          prop: "connect_username",
        },
        {
          label: "归档时间",
          prop: "return_at",
        },
        {
          label: "归档人",
          prop: "return_username",
        },
        {
          label: "驳回时间",
          prop: "reject_at",
        },
        {
          label: "驳回人",
          prop: "reject_username",
        },
      ],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1,
        pageSize: 30, // 每页显示条数
      },
      details: [],
      users: [],
      addDrawer: false,
      ContactDrawer: false,
      addData: {
        company_id: null,
        detail_ids: [],
        use_cause: "",
      },
    };
  },
  computed: {
    pageData: function () {
      let currentPage = this.search
        ? this.pageOption.searchCurrentPage
        : this.pageOption.currentPage;
      return this.recordApplicats
        .filter(
          (data) =>
            !this.search ||
            data.company_name.toLowerCase().includes(this.search.toLowerCase())
        )
        .slice(
          this.pageOption.pageSize * (currentPage - 1),
          this.pageOption.pageSize * currentPage
        );
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  watch: {
    search: function () {
      this.pageOption.total = this.search
        ? this.searchTotal()
        : this.recordApplicats.length;
      this.pageOption.searchCurrentPage = 1;
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  methods: {
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    getData(query) {
      this.$axios.post("/api/record/applicat_list", this.searchArr).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.recordApplicats = data.data.list;
          this.pageOption.total = this.recordApplicats.length;
          this.details = data.data.details;
          this.users = data.data.users;
        }
      });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
    },
    handleCurrentChange(val) {
      if (this.search) {
        this.pageOption.searchCurrentPage = val;
      } else {
        this.pageOption.currentPage = val;
      }
    },
    searchTotal() {
      return this.recordApplicats.filter(
        (data) =>
          !this.search ||
          data.company_name.toLowerCase().includes(this.search.toLowerCase())
      ).length;
    },
    handleAdd() {
      this.addDrawer = true;
    },
    handleAddBeforeClose(done) {
      this.addData.company_id = null;
      this.addData.detail_ids = [];
      this.addData.use_cause = "";
      done();
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleSave() {
      this.$axios.post("/api/record/record_applicat", this.addData).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          this.getData();
          this.addDrawer = false;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleGetOperate(id) {
      this.$axios.get("/api/record/applicat_operate_list/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.OperationRecord = data.data.operate_list;
          this.ContactDrawer = true;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleASearSub() {
      this.getData();
      this.activeOpen = '';
    },
    handleASearClear() {
      this.searchArr.applicat_at = "";
      this.searchArr.connect_at = "";
      this.searchArr.return_at = "";
      this.searchArr.reject_at = "";
      this.searchArr.applicat_uid = "";
      this.activeOpen = '';
      this.getData();
    },
    handleConnectApplicat(index, row) {
      this.$axios.post("/api/record/record_connect/" + row.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.pageData[index].applicat_status = data.data.applicat_row.applicat_status;
          this.pageData[index].status_name = data.data.applicat_row.status_name;
          this.pageData[index].connect_at = data.data.applicat_row.connect_at;
          this.pageData[index].connect_uid = data.data.applicat_row.connect_uid;
          this.pageData[index].connect_username = data.data.applicat_row.connect_username;
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleReturnApplicat(index, row) {
      this.$axios.post("/api/record/record_return/" + row.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.pageData[index].applicat_status = data.data.applicat_row.applicat_status;
          this.pageData[index].status_name = data.data.applicat_row.status_name;
          this.pageData[index].return_at = data.data.applicat_row.return_at;
          this.pageData[index].return_uid = data.data.applicat_row.return_uid;
          this.pageData[index].return_username = data.data.applicat_row.return_username;
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleRejectApplicat(index, row) {
      this.$axios.post("/api/record/record_reject/" + row.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.pageData[index].applicat_status = data.data.applicat_row.applicat_status;
          this.pageData[index].status_name = data.data.applicat_row.status_name;
          this.pageData[index].reject_at = data.data.applicat_row.reject_at;
          this.pageData[index].reject_uid = data.data.applicat_row.reject_uid;
          this.pageData[index].reject_username = data.data.applicat_row.reject_username;
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleAlertApplicat(row) {
      this.$axios.get("/api/record/applicat_sending/" + row.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
        } else {
          this.$message.error("提醒失败，请重试！");
        }
      });
    },
  },
  mounted() {
    this.getData();
    document.addEventListener('click', this.handleClickCollapseOutSide);
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
[v-cloak]
  display: none
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.record_connect >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .el-row
    margin-bottom: .4rem
  .el-select
    width: 100%
.record_connect
  marginLeft()
.tr
  text-align: right
.mt-10
  margin-top: .2rem
.search-row .el-col
  margin-bottom: .2rem
.count-style
  display: inline-block
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
.record_connect >>> .el-collapse-item__wrap
  position: fixed;
  width: -webkit-fill-available;
  z-index: 222 !important;
.middle-table 
  z-index: 1;
.page-footer
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
.pagination-style
  padding-top: 25px;
  text-align: right;
</style>



// WEBPACK FOOTER //
// src/pages/record_connect/record_connect.vue